import { AppErrorCode as LibraryAppErrorCode } from '@sendent/nextcloud-api';
import { ReduxAction, createReduxAction } from '../../utils';
import { AppErrorCode, NotificationStatus, appConstants } from './actionTypes';
import { LongOperation } from '../../reducers/app/reducer';
import { UploadFile } from '../../../model';

export enum OperationId {
    Logout = 'logout',
    SignIn = 'signin',
    AuthenticateMsTeams = 'authenticate_ms_teams',
    LoadUserConfiguration = 'load_user_configuration',
    UploadFile = 'upload_file',
    RenameFile = 'rename_file',
    DeleteFile = 'delete_file',
    CreateFolder = 'create_folder',
    OpenNextcloudFile = 'open_nextcloud_file',
    LoadConversationContext = 'load_conversation_context',
    EmailShare = 'email_share',
    GroupShare = 'group_share',
    ServerFileShare = 'server_file_share',
    LoadDndFiles = 'load_dnd_files',
    LoadTeamMemberContext = 'load_team_member_context',
}

export type StartFetchActionPayload = LongOperation;

export type StartFetchAction = ReduxAction<
    typeof appConstants.APP_START_FETCH,
    StartFetchActionPayload
>;

export const startFetch = (
    payload: StartFetchActionPayload,
): StartFetchAction => createReduxAction(appConstants.APP_START_FETCH, payload);

export type StopFetchActionPayload = {
    operationId: OperationId;
    status?: NotificationStatus;
    errorCode?: AppErrorCode | LibraryAppErrorCode;
    message?: string;
};

export type StopFetchAction = ReduxAction<
    typeof appConstants.APP_STOP_FETCH,
    StopFetchActionPayload
>;

export const stopFetch = (payload: StopFetchActionPayload): StopFetchAction =>
    createReduxAction(appConstants.APP_STOP_FETCH, payload);

export type UpdateFetchMessageActionPayload = {
    operationId: OperationId;
    message: string;
};

export type UpdateFetchMessageAction = ReduxAction<
    typeof appConstants.APP_UPDATE_FETCH_MESSAGE,
    UpdateFetchMessageActionPayload
>;

// Replaces the spinner text of a running operation, e.g. to append progress
export const updateFetchMessage = (
    payload: UpdateFetchMessageActionPayload,
): UpdateFetchMessageAction =>
    createReduxAction(appConstants.APP_UPDATE_FETCH_MESSAGE, payload);

type ShowNotificationPayload = {
    status: NotificationStatus;
    errorCode?: AppErrorCode | LibraryAppErrorCode;
    message: string;
};

export type ShowNotificationAction = ReduxAction<
    typeof appConstants.APP_SHOW_NOTIFICATION,
    ShowNotificationPayload
>;

export const showNotification = (
    payload: ShowNotificationPayload,
): ShowNotificationAction =>
    createReduxAction(appConstants.APP_SHOW_NOTIFICATION, payload);

export const setFilesToUpload = (
    filesToUpload: UploadFile[],
): ReduxAction<
    typeof appConstants.APP_FILES_TO_UPLOAD,
    { filesToUpload: UploadFile[] }
> => createReduxAction(appConstants.APP_FILES_TO_UPLOAD, { filesToUpload });

export const clearNotification = (): ReduxAction<
    typeof appConstants.APP_CLEAR_NOTIFICATION,
    undefined
> => createReduxAction(appConstants.APP_CLEAR_NOTIFICATION);

export const setProgressSize = (
    progressSize: number,
): ReduxAction<
    typeof appConstants.APP_PROGRESS_SIZE,
    { progressSize: number }
> => createReduxAction(appConstants.APP_PROGRESS_SIZE, { progressSize });

export const addUploadedSize = (
    uploadedSize: number,
): ReduxAction<
    typeof appConstants.APP_UPLOADED_SIZE,
    { uploadedSize: number }
> => createReduxAction(appConstants.APP_UPLOADED_SIZE, { uploadedSize });
